import {
  type PropsWithChildren,
  isValidElement,
  type ReactNode,
  Children,
} from 'react';

import { isSlot } from '../../core/utils/is-slot.js';
import { devLog } from '../../core/utils/logging.js';
import { Flex } from '../flex/Flex.js';
import { HelpMenu } from '../help-menu/HelpMenu.js';

type Slots = {
  custom: ReactNode | null;
  helpMenu: ReactNode | null;
};

function getItemSlots(children: ReactNode) {
  const slots: Slots = {
    helpMenu: null,
    custom: null,
  };

  for (const child of Children.toArray(children)) {
    if (isValidElement(child)) {
      if (isSlot(child, HelpMenu)) {
        slots.helpMenu = child;
      } else {
        slots.custom = child;
      }
    } else {
      devLog('The used child is not supported by the AppHeader.');
    }
  }

  return slots;
}

/**
 * An `AppHeader` slot for menus like the `HelpMenu`.
 * @returns
 */
export const Menus = (props: PropsWithChildren) => {
  const slots = getItemSlots(props.children);

  return (
    <Flex alignItems="center" gap={4}>
      {slots.custom}
      {slots.helpMenu}
    </Flex>
  );
};
